const API_URL_BASE = "https://www.trp.trimble.com";
const REDIRECT_URL = "https://www.trp.trimble.com";
export const env = {
    apiURL: `${API_URL_BASE}/api/`,
    loginURL: `${API_URL_BASE}/api/auth/okta/login`,
    loginURLWithRedirect: `${API_URL_BASE}/api/auth/okta/login?redirect_uri=${REDIRECT_URL}`,
    logoutURL: `https://stage.id.trimblecloud.com/oauth/logout?post_logout_redirect_uri=${REDIRECT_URL}&id_token_hint=`,
};